import React from 'react';
type SectionHeadingProps = {
  id: string;
  children: React.ReactNode;
  className?: string;
};
export function SectionHeading({
  id,
  children,
  className = ''
}: SectionHeadingProps) {
  return <div className={`text-center ${className}`} data-id="element-227" data-mp="vytka0m3k6hk">
      <h2 id={id} className="mx-auto max-w-3xl text-balance text-4xl font-bold leading-[1.05] tracking-tight text-white sm:text-5xl" data-id="element-228" data-mp="vxjo5gyt18dk">
        {children}
      </h2>
      <span className="mx-auto mt-4 flex w-fit items-center gap-1" aria-hidden="true" data-id="element-229" data-mp="mzq1yyur7v44">
        <span className="h-1 w-10 rounded-full bg-electric" data-id="element-230" data-mp="i7ohwqrch03j" />
        <span className="h-1 w-3 rounded-full bg-gold" data-id="element-231" data-mp="i64zoum4oez4" />
      </span>
    </div>;
}